import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastModule, ToastOptions } from 'ng2-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SupportFormService } from './layout/support-form/support-form-service';
import { AuthGuard } from './shared';
import { AppInterceptor } from './app.interceptor';
import { MyFilterPipe } from './shared/pipes/role.filter';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { NgxUiLoaderModule,NgxUiLoaderHttpModule,NgxUiLoaderConfig,SPINNER,POSITION} from  'ngx-ui-loader';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsPosition: POSITION.centerCenter,
    bgsType: SPINNER.rectangleBounceParty,
    bgsOpacity: 1.5,
    overlayColor: "rgba(40, 40, 40, 0.8)"
  };
  

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    // for development
    // return new TranslateHttpLoader(http, '/start-angular/SB-Admin-BS4-Angular-5/master/dist/assets/i18n/', '.json');
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export class CustomOptions extends ToastOptions {
    animate = 'flyRight';
    dismiss = 'auto';
    showCloseButton = true;
    newestOnTop = true;
    enableHTML = true;
    // messageClass = '';
    // titleClass = '';
}


@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        HttpClientModule,
        NgxUiLoaderHttpModule,
        LoggerModule.forRoot({level: NgxLoggerLevel.OFF}),
        ToastModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule
    ],
    declarations: [MyFilterPipe, AppComponent],
    providers: [AuthGuard, {
        provide: HTTP_INTERCEPTORS,
        useClass: AppInterceptor,
        multi: true,
    },SupportFormService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts